  document.addEventListener('DOMContentLoaded', function () {
    const carousel = document.querySelector('.article-carousel');
    if (!carousel) return;

    const track = carousel.querySelector('.article-carousel-track');
    let slides = carousel.querySelectorAll('.article-carousel-slide');
    const dotsContainer = carousel.querySelector('.article-carousel-dots');
    let currentSlide = 0;

    const firstSlideClone = slides[0].cloneNode(true);
    const lastSlideClone = slides[slides.length - 1].cloneNode(true);
    track.appendChild(firstSlideClone);
    track.insertBefore(lastSlideClone, slides[0]);
    slides = carousel.querySelectorAll('.article-carousel-slide');

    currentSlide = 1;
    track.style.transition = 'none';
    track.style.transform = `translateX(-${currentSlide * 100}%)`;
    void track.offsetWidth;
    track.style.transition = 'transform 0.5s ease';

    for (let i = 0; i < slides.length - 2; i++) {
      const dot = document.createElement('button');
      if (i === 0) dot.classList.add('active');
      dot.setAttribute('aria-label', `第 ${i + 1} 张幻灯片`);
      dot.addEventListener('click', () => {
        currentSlide = i + 1;
        updateSlide();
      });
      dotsContainer.appendChild(dot);
    }

    const lazyImages = document.querySelectorAll('.lazy-image');
    if ('IntersectionObserver' in window) {
      const lazyLoadObserver = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const img = entry.target;
              img.src = img.dataset.src;
              img.classList.add('loaded');
              lazyLoadObserver.unobserve(img);
            }
          });
        },
        {
          rootMargin: '500px 0px',
          threshold: 0.01,
        }
      );
      lazyImages.forEach((img) => lazyLoadObserver.observe(img));
    } else {
      lazyImages.forEach((img) => {
        img.src = img.dataset.src;
        img.classList.add('loaded');
      });
    }

    function preloadAdjacentSlides() {
      const realIndex = currentSlide - 1;
      [realIndex - 1, realIndex, realIndex + 1].forEach((index) => {
        if (index >= 0 && index < slides.length - 2) {
          const slide = slides[index + 1];
          slide.querySelectorAll('.lazy-image:not(.loaded)').forEach((img) => {
            img.src = img.dataset.src;
            img.classList.add('loaded');
          });
        }
      });
    }

    function updateSlide() {
      track.style.transform = `translateX(-${currentSlide * 100}%)`;
      const dots = dotsContainer.querySelectorAll('button');
      dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === currentSlide - 1);
      });
      preloadAdjacentSlides();
    }

    function nextSlide() {
      currentSlide++;
      track.style.transition = 'transform 0.5s ease';
      updateSlide();
      if (currentSlide === slides.length - 1) {
        setTimeout(() => {
          track.style.transition = 'none';
          currentSlide = 1;
          updateSlide();
          void track.offsetWidth;
          track.style.transition = 'transform 0.5s ease';
        }, 500);
      }
    }

    function prevSlide() {
      currentSlide--;
      track.style.transition = 'transform 0.5s ease';
      updateSlide();
      if (currentSlide === 0) {
        setTimeout(() => {
          track.style.transition = 'none';
          currentSlide = slides.length - 2;
          updateSlide();
          void track.offsetWidth;
          track.style.transition = 'transform 0.5s ease';
        }, 500);
      }
    }

    if (slides.length > 3) {
      const prevButton = carousel.querySelector('.article-carousel-prev');
      const nextButton = carousel.querySelector('.article-carousel-next');
      prevButton.addEventListener('click', prevSlide);
      nextButton.addEventListener('click', nextSlide);
    }

    if ('ontouchstart' in window) {
      let startX = 0,
        startY = 0,
        isScrolling = false,
        threshold = 50;
      carousel.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        isScrolling = undefined;
      });
      carousel.addEventListener('touchmove', function (e) {
        if (typeof isScrolling === 'undefined') {
          const diffX = Math.abs(e.touches[0].clientX - startX);
          const diffY = Math.abs(e.touches[0].clientY - startY);
          isScrolling = diffY > diffX;
        }
        if (!isScrolling) e.preventDefault();
      });
      carousel.addEventListener('touchend', function (e) {
        if (isScrolling) return;
        const endX = e.changedTouches[0].clientX;
        const distance = endX - startX;
        if (distance > threshold) prevSlide();
        else if (distance < -threshold) nextSlide();
      });
    }

    if (!('ontouchstart' in window)) {
      let isDragging = false,
        startX = 0,
        dragThreshold = 50;
      carousel.addEventListener('mousedown', function (e) {
        e.preventDefault();
        isDragging = true;
        startX = e.clientX;
        carousel.classList.add('dragging');
        track.style.transition = 'none';
      });
      document.addEventListener('mousemove', function (e) {
        if (!isDragging) return;
        const deltaX = e.clientX - startX;
        track.style.transform = `translateX(${-currentSlide * 100 + (deltaX / carousel.clientWidth) * 100}%)`;
      });
      document.addEventListener('mouseup', function (e) {
        if (!isDragging) return;
        isDragging = false;
        carousel.classList.remove('dragging');
        const deltaX = e.clientX - startX;
        track.style.transition = 'transform 0.5s ease';
        if (deltaX > dragThreshold) prevSlide();
        else if (deltaX < -dragThreshold) nextSlide();
        else updateSlide();
      });
    }

    preloadAdjacentSlides();
  });